<script>
    import { Link, navigate } from 'svelte-routing';
    export let notes;
    
    const createNewPost = () => {
        fetch(`/api/v1/post/new`, {
            method: 'POST',
        })
        .then(data => data.json())
        .then(response => {
            const { postUid } = response;
            if (postUid) {
                navigate(`/notes/${postUid}`);
            }
        });
    }
</script>

<main>
    <button on:click="{createNewPost}">New Note</button>
    {#each notes as note}
        <div class="note-list-item-container">
            <Link to="/notes/{note.uuid}">
                <div class="note-list-item">
                    {note.slug || note.uuid}
                </div>
            </Link>
        </div>
    {/each}
</main>

<style>
    .note-list-item-container {
        margin-bottom: 20px;
    }
    .note-list-item {
        display: flex;
        padding: 30px;
        background-color:rgb(5,5,5);
        color: rgb(150,150,150);
    }

    @media (max-width: 640px) {}
</style>